import graphql from 'babel-plugin-relay/macro'
import React, { useState } from 'react'
import { createPaginationContainer } from 'react-relay'
import { withRouter } from 'react-router-dom'
import { Table } from 'semantic-ui-react'
import Filters from 'components/Filters'
import useEffectAfterMount from 'hooks/useEffectAfterMount'

function VehicleIncidentTypeTable({ history, relay, viewer }) {
  const [filters, setFilters] = useState([])
  const [numRows, setNumRows] = useState(20)
  const [loading, setLoading] = useState(false)

  const incidentTypes = viewer.vehicleIncidentTypes.edges
    .map(({ node }) => node)
    .sort((a, b) => parseInt(a.code) - parseInt(b.code))

  useEffectAfterMount(() => {
    setLoading(true)
    relay.refetchConnection(numRows, () => setLoading(false), {
      orderBy: ['code'],
      order: 'ASC',
      where: filters.length > 0 ? { and: filters } : null
    })
  }, [numRows, filters])

  const handleRowClick = (incidentType) => () => {
    history.push(`/vehicle-incidents-type/${incidentType.id}`)
  }

  return (
    <div style={{ overflowX: 'auto' }}>
      <Filters
        filters={filters}
        setFilters={setFilters}
        numRows={numRows}
        setNumRows={setNumRows}
      />
      
      <Table striped selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Código</Table.HeaderCell>
            <Table.HeaderCell>Nombre</Table.HeaderCell>
            <Table.HeaderCell>Kilometraje Sugerido</Table.HeaderCell>
            <Table.HeaderCell>Meses Sugeridos</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {incidentTypes.map(incidentType => (
            <Table.Row key={incidentType.id} onClick={handleRowClick(incidentType)}>
              <Table.Cell>{incidentType.code}</Table.Cell>
              <Table.Cell>{incidentType.name}</Table.Cell>
              <Table.Cell>{incidentType.suggestedMileage || '-'}</Table.Cell>
              <Table.Cell>{incidentType.suggestedMonths || '-'}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>

      {loading && <div style={{ padding: '20px', textAlign: 'center' }}>Cargando más registros...</div>}
    </div>
  )
}

export default createPaginationContainer(
  withRouter(VehicleIncidentTypeTable),
  {
    viewer: graphql`
      fragment VehicleIncidentTypeTable_viewer on Viewer
        @argumentDefinitions(
          count: { type: "Int", defaultValue: 20 }
          cursor: { type: "String" }
          orderBy: { type: "[VehicleIncidentTypeFieldType]", defaultValue: ["code"] }
          order: { type: "OrderEnum", defaultValue: ASC }
          where: { type: "VehicleIncidentTypeWhere", defaultValue: null }
        ) {
        vehicleIncidentTypes(
          first: $count
          after: $cursor
          orderBy: $orderBy
          order: $order
          where: $where
        ) @connection(key: "VehicleIncidentTypeTable_vehicleIncidentTypes") {
          edges {
            node {
              id
              code
              name
              suggestedMileage
              suggestedMonths
              isDisabled
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    `,
  },
  {
    direction: 'forward',
    getConnectionFromProps(props) {
      return props.viewer && props.viewer.vehicleIncidentTypes
    },
    getFragmentVariables(prevVars, totalCount) {
      return { ...prevVars, count: totalCount }
    },
    getVariables(props, { count, cursor }, fragmentVariables) {
      return { 
        ...fragmentVariables, 
        count, 
        cursor,
        orderBy: ['code'],
        order: ['ASC'],
        where: fragmentVariables.where
      }
    },
    query: graphql`
      query VehicleIncidentTypeTableQuery(
        $count: Int!
        $cursor: String
        $orderBy: [VehicleIncidentTypeFieldType] = [code]
        $order: OrderEnum = ASC
        $where: VehicleIncidentTypeWhere
      ) {
        viewer {
          ...VehicleIncidentTypeTable_viewer @arguments(
            count: $count
            cursor: $cursor
            orderBy: $orderBy
            order: $order
            where: $where
          )
        }
      }
    `,
  }
)